import Navigation from './Navigation';
import Footer from './Footer';
import CustomCursor from '../CustomCursor';
import WhatsAppButton from '../WhatsAppButton';
import TelegramButton from '../TelegramButton';
import LiveChat from '../chat/LiveChat';
import TawkChat from '../TawkChat';
import { LegacyAbout } from '../LegacyAbout';
import VisitorTracker from '../VisitorTracker';
import useScrollAnimations from '../../hooks/useScrollAnimations';
import { useEffect } from 'react';
import { loadTrackers } from '../../utils/tracking';

const Layout = ({ children }) => {
  useScrollAnimations();
  useEffect(() => { loadTrackers(); }, []);
  return (
    <div className="min-h-screen flex flex-col cursor-hidden">
      <CustomCursor />
      <VisitorTracker />
      <Navigation />
      <main className="flex-1">
        {children}
        <LegacyAbout />
      </main>
      <Footer />
      <TelegramButton />
      <WhatsAppButton />
      <LiveChat />
      <TawkChat />
    </div>
  );
};

export default Layout;
